import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/chevron-down.svg'


const _hoisted_1 = { class: "package-info" }
const _hoisted_2 = {
  key: 0,
  class: "package-name"
}
const _hoisted_3 = { class: "package-cost" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "section-name" }
const _hoisted_7 = {
  key: 0,
  class: "section-list"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "section-text" }
const _hoisted_10 = {
  key: 0,
  class: "separator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inclusion-column", { selected: $props.isSelected, 'not-selected': $props.hasSelected && !$props.isSelected }])
  }, [
    _createElementVNode("div", {
      class: "package-header",
      onClick: $setup.onHeaderClick
    }, [
      _createElementVNode("div", _hoisted_1, [
        ($setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.pack.inclusionId.type), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, _toDisplayString($props.pack.price === 0 ? "No Additional Cost" : $setup.formatPrice($props.pack.price)), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["toggle-wrapper", { mobile: !$setup.isDesktop }])
      }, [
        _createVNode($setup["ToggleButton"], {
          class: "toggle-button",
          modelValue: !!$props.isSelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onSelect', $props.pack)))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: _normalizeClass(["selected-text", { 'hidden-text': !$props.isSelected }])
        }, "Selected", 2)
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["package-content", { isSelected: $props.isSelected, isNotSelected: !$props.isSelected }])
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "separator" }, null, -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pack.inclusionId.inclusions, (inclusion, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: inclusion.name
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "section-header",
              onClick: ($event: any) => ($setup.toggleSection(inclusion.name))
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(inclusion.name), 1),
              _createElementVNode("img", {
                class: _normalizeClass(["chevron", { expanded: $props.expandedSections[inclusion.name] }]),
                src: _imports_0,
                alt: "expand"
              }, null, 2)
            ], 8, _hoisted_5),
            _createVNode(_Transition, { name: "expand" }, {
              default: _withCtx(() => [
                ($props.expandedSections[inclusion.name])
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                      (inclusion.url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: _normalizeClass(["section-img", { mobile: !$setup.isDesktop }]),
                            src: inclusion.url
                          }, null, 10, _hoisted_8))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inclusion.description, (desc) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "section-item",
                            key: desc
                          }, _toDisplayString(desc), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          (index !== $props.pack.inclusionId.inclusions.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ], 2)
  ], 2))
}